var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useRef } from "react";
import { FaGoogle } from "react-icons/fa";
import { Facebook, Instagram } from "lucide-react";
import { getPlatformsData } from "../actions/platforms";
import { getAgencyName, getUserData } from "../actions/users";
import { getNextTip, markTipAsSeen } from "../actions/tips";
import PlatformHeader from "../components/home/PlatformHeader";
import ClientRow from "../components/home/ClientRow";
import PaginationFooter from "../components/layout/PaginationFooter";
import useProgress from "../hooks/useProgress";
import usePagination from "../hooks/usePagination";
import HeaderHome from "../components/layout/HeaderHome";
import { calculateClientsPerPage } from "../utils/helpers";
import ProgressLoader from "../components/layout/ProgressLoader";
import Footer from "../components/layout/Footer";
import MobileDashboard from "../components/home/MobileDashboard";
import ErrorBoundary from "../components/common/ErrorBoundary";
import TipModal from "../components/tips/TipModal";
// ✅ Importar sistema de alertas
import { playSound, SoundType } from "../utils/audioAlerts";
import { detectAlerts, clearNotifiedAlerts } from "../utils/alertDetector";
import AlertModal from "../components/alerts/AlertModal";
import ClientsBanner from "../components/home/ClientsBanner";
var AUTO_PAGE_SECONDS = 8;
var Home = function () {
    var _a = useState([]), clients = _a[0], setClients = _a[1];
    var _b = useState([]), previousClients = _b[0], setPreviousClients = _b[1];
    var _c = useState(1), clientsPerPage = _c[0], setClientsPerPage = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(0), progress = _e[0], setProgress = _e[1];
    var _f = useState(""), lastUpdated = _f[0], setLastUpdated = _f[1];
    var _g = useState(""), nextUpdate = _g[0], setNextUpdate = _g[1];
    var _h = useState(""), agencyName = _h[0], setAgencyName = _h[1];
    var clientRowRef = useRef(null);
    var _j = useState(true), isPaused = _j[0], setIsPaused = _j[1];
    var _k = useState(true), showJoyride = _k[0], setShowJoyride = _k[1];
    var _l = useState(window.innerWidth <= 900), isMobile = _l[0], setIsMobile = _l[1];
    var _m = useState(null), currentTip = _m[0], setCurrentTip = _m[1];
    var _o = useState(false), showTipModal = _o[0], setShowTipModal = _o[1];
    var _p = useState(false), instagramMinimized = _p[0], setInstagramMinimized = _p[1];
    var _q = useState(false), googleMinimized = _q[0], setGoogleMinimized = _q[1];
    var _r = useState(false), facebookMinimized = _r[0], setFacebookMinimized = _r[1];
    // ✅ Estados para alertas
    var _s = useState([]), alerts = _s[0], setAlerts = _s[1];
    var _t = useState(false), showAlertModal = _t[0], setShowAlertModal = _t[1];
    var _u = useState(new Set()), notifiedAlerts = _u[0], setNotifiedAlerts = _u[1]; // ✅ Novo estado para rastrear alertas já notificados
    // ✅ 1. Limpa notificações quando o usuário volta para a aba
    useEffect(function () {
        var handleVisibilityChange = function () {
            if (!document.hidden) {
                clearNotifiedAlerts();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function () { return document.removeEventListener('visibilitychange', handleVisibilityChange); };
    }, []);
    // ✅ 2. Handler para fechar modal de alertas
    var handleCloseAlertModal = function () {
        setShowAlertModal(false);
        clearNotifiedAlerts();
        setNotifiedAlerts(new Set()); // ✅ Limpa o rastreamento local ao fechar
    };
    // 3. Busca dados iniciais das plataformas
    useEffect(function () {
        setLoading(true);
        var currentProgress = 0;
        var interval = setInterval(function () {
            currentProgress += 10;
            setProgress(Math.min(currentProgress, 90));
        }, 200);
        getPlatformsData()
            .then(function (res) {
            var fetchedClients = res.data.data || [];
            setClients(fetchedClients);
            setPreviousClients(fetchedClients);
            setLastUpdated(res.data.last_update || "");
            setNextUpdate(res.data.next_update || "");
            setProgress(100);
        })
            .catch(function (error) {
            console.error("❌ Erro ao buscar dados das plataformas:", error);
            setClients([]);
            setProgress(100);
        })
            .finally(function () {
            clearInterval(interval);
            setLoading(false);
        });
    }, []);
    // 4. Calcula o maior número de campanhas de qualquer plataforma
    var getMaxCampaigns = function (clients) {
        return clients.reduce(function (max, client) {
            var _a, _b, _c, _d, _e, _f;
            var maxClientCampaigns = Math.max(((_b = (_a = client.facebook) === null || _a === void 0 ? void 0 : _a.campaigns) === null || _b === void 0 ? void 0 : _b.length) || 0, ((_d = (_c = client.google) === null || _c === void 0 ? void 0 : _c.campaigns) === null || _d === void 0 ? void 0 : _d.length) || 0, ((_f = (_e = client.instagram) === null || _e === void 0 ? void 0 : _e.campaigns) === null || _f === void 0 ? void 0 : _f.length) || 0);
            return Math.max(max, maxClientCampaigns);
        }, 0);
    };
    var maxCampaigns = getMaxCampaigns(clients);
    // Define altura fixa baseada no maior número de campanhas
    var clientRowHeight = 130;
    if (maxCampaigns >= 5)
        clientRowHeight = 245;
    else if (maxCampaigns >= 3)
        clientRowHeight = 192;
    else if (maxCampaigns >= 1)
        clientRowHeight = 130;
    // 5. Calcula quantos clientes cabem na tela
    useEffect(function () {
        var handleResize = function () {
            setClientsPerPage(calculateClientsPerPage(clientRowHeight));
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, [clientRowHeight]);
    var _v = usePagination(clients.length, clientsPerPage), currentPage = _v.currentPage, totalPages = _v.totalPages, goToNextPage = _v.goToNextPage, goToPreviousPage = _v.goToPreviousPage;
    var autoProgress = useProgress(AUTO_PAGE_SECONDS, currentPage, clients.length, clientsPerPage, isPaused);
    var startIndex = currentPage * clientsPerPage;
    var endIndex = (currentPage + 1) * clientsPerPage;
    var noClientsFound = !loading && clients.length === 0;
    // 6. Busca nome da agência
    useEffect(function () {
        getAgencyName()
            .then(function (agencia) { return setAgencyName(agencia.agency_name); })
            .catch(function (err) { return console.error("Erro ao buscar o nome da agência:", err); });
    }, []);
    // 7. Paginação automática
    useEffect(function () {
        if (loading || totalPages <= 1 || isPaused)
            return;
        var timer = setInterval(function () {
            if (autoProgress >= 99.9) {
                goToNextPage();
            }
        }, 100);
        return function () { return clearInterval(timer); };
    }, [autoProgress, loading, totalPages, goToNextPage, currentPage, isPaused]);
    // ✅ 8. Atualização automática COM detecção de alertas
    useEffect(function () {
        if (!nextUpdate)
            return;
        var interval = setInterval(function () {
            var now = new Date();
            var next = new Date(nextUpdate);
            if (now >= next) {
                // console.log("🔄 Atualizando dados das plataformas...");
                getPlatformsData()
                    .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                    var fetchedClients, isDifferent, detectedAlerts, newAlerts_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                fetchedClients = res.data.data || [];
                                isDifferent = JSON.stringify(fetchedClients) !== JSON.stringify(clients);
                                if (isDifferent) {
                                    playSound(SoundType.UPDATE);
                                }
                                if (!(previousClients.length > 0)) return [3 /*break*/, 2];
                                return [4 /*yield*/, detectAlerts(previousClients, fetchedClients)];
                            case 1:
                                detectedAlerts = _a.sent();
                                newAlerts_1 = detectedAlerts.filter(function (alert) { return !notifiedAlerts.has(alert.id || "".concat(alert.platform, "-").concat(alert.clientId, "-").concat(alert.message)); });
                                if (newAlerts_1.length > 0) {
                                    // console.log('🚨 ALERTAS DETECTADOS (novos):', newAlerts);
                                    setAlerts(newAlerts_1);
                                    setShowAlertModal(true);
                                    playSound(SoundType.ALERT);
                                    // ✅ Atualiza o conjunto de alertas notificados
                                    setNotifiedAlerts(function (prev) { return new Set(__spreadArray(__spreadArray([], prev, true), newAlerts_1.map(function (alert) { return alert.id || "".concat(alert.platform, "-").concat(alert.clientId, "-").concat(alert.message); }), true)); });
                                }
                                _a.label = 2;
                            case 2:
                                // ✅ Atualiza estados
                                setPreviousClients(clients);
                                setClients(fetchedClients);
                                setLastUpdated(res.data.last_update || "");
                                setNextUpdate(res.data.next_update || "");
                                return [2 /*return*/];
                        }
                    });
                }); })
                    .catch(function (error) {
                    console.error("❌ Erro ao buscar dados das plataformas:", error);
                    setClients([]);
                });
            }
        }, 10000); // ✅ Verifica a cada 10 segundos
        return function () { return clearInterval(interval); };
    }, [nextUpdate, clients, previousClients, notifiedAlerts]); // ✅ Adiciona notifiedAlerts como dependência
    // 9. Verifica se deve mostrar tutorial
    useEffect(function () {
        getUserData()
            .then(function (res) {
            if (res.data && res.data.tutorial_seen === false) {
                setShowJoyride(true);
            }
        })
            .catch(function (err) {
            console.error("Erro ao buscar dados do usuário:", err);
        });
    }, []);
    var handleFinishTutorial = function () {
        // Tutorial concluído
    };
    // 10. Detecta redimensionamento para mobile/desktop
    useEffect(function () {
        var handleResize = function () { return setIsMobile(window.innerWidth <= 640); };
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, []);
    // 11. Busca dica do dia
    useEffect(function () {
        var fetchTip = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getNextTip('dashboard')];
                    case 1:
                        response = _a.sent();
                        if (response.has_tip && response.tip) {
                            setCurrentTip(response.tip);
                            setShowTipModal(true);
                            // console.log('📌 Dica recebida:', response.tip);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('❌ Erro ao buscar dica:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (!loading) {
            fetchTip();
        }
    }, [loading]);
    var handleDismissTip = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!currentTip) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, markTipAsSeen(currentTip.tip_id, 'dashboard')];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error('❌ Erro ao marcar dica como vista:', error_2);
                    return [3 /*break*/, 4];
                case 4:
                    setShowTipModal(false);
                    setCurrentTip(null);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        console.log("instagramMinimized:", instagramMinimized);
    }, [instagramMinimized]);
    return (React.createElement("div", { className: "min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-100 relative" },
        React.createElement(HeaderHome, { agencyName: agencyName, showNoClientsTooltip: noClientsFound }),
        React.createElement(ErrorBoundary, null,
            loading ? (React.createElement(ProgressLoader, { progress: progress })) : isMobile ? (React.createElement(React.Fragment, null,
                React.createElement(MobileDashboard, { clients: clients }),
                React.createElement("div", { className: "col-span-5 flex flex-col items-center justify-center py-20 px-4" },
                    React.createElement(ClientsBanner, { clientsCount: clients.length })))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "w-full results-container" },
                    React.createElement("div", { className: "bg-gray-800/30" },
                        React.createElement("div", { className: "tutorial-home-container grid " +
                                (instagramMinimized
                                    ? "grid-cols-[90px_1fr_1fr_80px_30px] 2xl:grid-cols-[170px_1fr_1fr_80px_40px]"
                                    : "grid-cols-[90px_1fr_1fr_1fr_30px] 2xl:grid-cols-[170px_1fr_1fr_1fr_40px]") }, noClientsFound ? (React.createElement("div", { className: "col-span-5 flex flex-col items-center justify-center py-20 px-4" },
                            React.createElement("div", { className: "text-9xl mb-6 animate-bounce" }, "\uD83D\uDE80"),
                            React.createElement("h3", { className: "text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-blue-400 to-pink-400 mb-4" }, "Ops! Parece que voc\u00EA est\u00E1 voando solo aqui..."),
                            React.createElement("p", { className: "text-gray-400 text-xl mb-8 text-center max-w-2xl" }, "Nenhum cliente em monitoramento ainda. Que tal adicionar alguns e come\u00E7ar a decolar? \uD83D\uDEEB"),
                            React.createElement("div", { className: "flex gap-4 items-center mb-6" },
                                React.createElement("div", { className: "flex flex-col items-center" },
                                    React.createElement("div", { className: "text-4xl mb-2" }, "\uD83D\uDCCA"),
                                    React.createElement("span", { className: "text-sm text-gray-500" }, "M\u00E9tricas")),
                                React.createElement("div", { className: "text-gray-600 text-2xl" }, "\u2192"),
                                React.createElement("div", { className: "flex flex-col items-center" },
                                    React.createElement("div", { className: "text-4xl mb-2" }, "\uD83D\uDCC8"),
                                    React.createElement("span", { className: "text-sm text-gray-500" }, "Crescimento")),
                                React.createElement("div", { className: "text-gray-600 text-2xl" }, "\u2192"),
                                React.createElement("div", { className: "flex flex-col items-center" },
                                    React.createElement("div", { className: "text-4xl mb-2" }, "\uD83C\uDFAF"),
                                    React.createElement("span", { className: "text-sm text-gray-500" }, "Resultados"))),
                            React.createElement("button", { onClick: function () { return window.location.href = '/clients'; }, className: "animate-pulse-slow px-8 py-4 rounded-xl bg-gradient-to-r from-green-500 to-blue-500 text-white font-bold text-lg shadow-xl hover:from-green-600 hover:to-blue-600 transition-all duration-300 transform hover:scale-105 flex items-center gap-3" },
                                React.createElement("span", null, "\u2728"),
                                React.createElement("span", null, "Adicionar meu primeiro cliente"),
                                React.createElement("span", null, "\uD83C\uDF89")),
                            React.createElement("p", { className: "text-gray-500 text-sm mt-4 italic" }, "(Prometo que vai ser r\u00E1pido \u2014 menos de 2 minutos! \u23F1\uFE0F)"))) : (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "bg-gray-900 p-1 flex items-center " },
                                React.createElement("h2", { className: "text-2xl font-semibold px-4 text-white-fallback" })),
                            React.createElement(PlatformHeader, { icon: FaGoogle, name: "Google ADS", colorClass: "bg-gradient-to-r from-[#16a34a] to-[#16a34a] text-white-fallback", instagramMinimized: instagramMinimized, setInstagramMinimized: setInstagramMinimized }),
                            React.createElement(PlatformHeader, { icon: Facebook, name: "Facebook ADS", colorClass: "bg-gradient-to-r from-[#2563eb] to-[#2563eb] text-white-fallback", instagramMinimized: instagramMinimized, setInstagramMinimized: setInstagramMinimized }),
                            React.createElement(PlatformHeader, { icon: Instagram, name: "Instagram", colorClass: "bg-gradient-to-r from-[#db2777] to-[#db2777] text-white-fallback", instagramMinimized: instagramMinimized, setInstagramMinimized: setInstagramMinimized }),
                            React.createElement("div", { className: "bg-blue-600" }),
                            clients.slice(startIndex, endIndex).map(function (client, index) { return (React.createElement(ClientRow, { instagramMinimized: instagramMinimized, key: client.id || index, client: client, forwardRef: index === 0 ? clientRowRef : undefined, height: clientRowHeight })); }),
                            React.createElement("div", { className: "col-span-5 flex flex-col items-center justify-center py-20 px-4" },
                                React.createElement(ClientsBanner, { clientsCount: clients.length }))))))),
                !noClientsFound && totalPages > 1 && (React.createElement(PaginationFooter, { currentPage: currentPage, totalPages: totalPages, goToNextPage: goToNextPage, goToPreviousPage: goToPreviousPage, progress: autoProgress, isPaused: isPaused, onTogglePause: function () { return setIsPaused(!isPaused); } })))),
            React.createElement(Footer, { lastUpdated: lastUpdated, nextUpdate: nextUpdate })),
        !noClientsFound && showTipModal && currentTip && (React.createElement(TipModal, { tip: currentTip, onDismiss: handleDismissTip })),
        showAlertModal && alerts.length > 0 && (React.createElement(AlertModal, { alerts: alerts, onClose: handleCloseAlertModal }))));
};
export default Home;
